import api from './client';

export const getCurrentUser = () => api('/auth/session').then(({ user }) => user);
export const getUserData = () => api('/auth/session').then(({ user }) => user);
export const updateCurrentUser = (uid, update) => api('/auth/profile', { method: 'PATCH', body: update });
export const getRegistrationStatus = () => api('/auth/status');
export const doSignup = (username, password, displayName) => api('/auth/register', { method: 'POST', body: { username, password, displayName } });
export const doLogin = (username, password) => api('/auth/login', { method: 'POST', body: { username, password } });
export const doLogout = () => api('/auth/logout', { method: 'POST' });
